var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDragIndicator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1655_2025)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.33268 12.0003C7.33268 12.7337 6.73268 13.3337 5.99935 13.3337C5.26602 13.3337 4.66602 12.7337 4.66602 12.0003C4.66602 11.267 5.26602 10.667 5.99935 10.667C6.73268 10.667 7.33268 11.267 7.33268 12.0003ZM5.99935 6.66699C5.26602 6.66699 4.66602 7.26699 4.66602 8.00033C4.66602 8.73366 5.26602 9.33366 5.99935 9.33366C6.73268 9.33366 7.33268 8.73366 7.33268 8.00033C7.33268 7.26699 6.73268 6.66699 5.99935 6.66699ZM5.99935 2.66699C5.26602 2.66699 4.66602 3.26699 4.66602 4.00033C4.66602 4.73366 5.26602 5.33366 5.99935 5.33366C6.73268 5.33366 7.33268 4.73366 7.33268 4.00033C7.33268 3.26699 6.73268 2.66699 5.99935 2.66699ZM9.99935 5.33366C10.7327 5.33366 11.3327 4.73366 11.3327 4.00033C11.3327 3.26699 10.7327 2.66699 9.99935 2.66699C9.26602 2.66699 8.66602 3.26699 8.66602 4.00033C8.66602 4.73366 9.26602 5.33366 9.99935 5.33366ZM9.99935 6.66699C9.26602 6.66699 8.66602 7.26699 8.66602 8.00033C8.66602 8.73366 9.26602 9.33366 9.99935 9.33366C10.7327 9.33366 11.3327 8.73366 11.3327 8.00033C11.3327 7.26699 10.7327 6.66699 9.99935 6.66699ZM9.99935 10.667C9.26602 10.667 8.66602 11.267 8.66602 12.0003C8.66602 12.7337 9.26602 13.3337 9.99935 13.3337C10.7327 13.3337 11.3327 12.7337 11.3327 12.0003C11.3327 11.267 10.7327 10.667 9.99935 10.667Z",
    fill: "#3D1CAF",
    fillOpacity: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1655_2025"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragIndicator);
export default __webpack_public_path__ + "static/media/DragIndicator.6932059af0820ce6af0543ed5b45e91e.svg";
export { ForwardRef as ReactComponent };